'use client'

import React, { useEffect } from 'react'
import BF2025 from '../Shop/BF2025'
import styles from './styles.module.css'
// Offers migrated off Overmind (Phase D1): the render-time offers come from the
// RegionOffers seam (server-prop grid / full-after-fetch store offers); the
// post-mount full-offers fetch is the offers store's ensureFullOffers.
import { useRegionOffers } from '../../RegionOffers'
import { useRegionCountryCode } from '../../RegionGeo'
import { useOffersStore } from '../../../store/offersStore'

function BF2024Page({  }) {
  const { offers, offersLoading } = useRegionOffers()
  const region = useRegionCountryCode()
  const ensureFullOffers = useOffersStore((s) => s.ensureFullOffers)

  useEffect(() => {
    // ensureFullOffers is idempotent (store-level #188 dedup + #187 full-vs-grid),
    // subsuming the former `!shopItemsFetched && !shopItemsLoading` gate.
    ensureFullOffers(region)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex items-center justify-center">
      <div className={styles.contentWrapper}>
        <BF2025 isLoading={offersLoading} items={offers}/>
      </div>
    </div>
  )
}

export default BF2024Page
